import {
  CREATE_OPTOMETRIA_NEONATOS_REQUEST,
  CREATE_OPTOMETRIA_NEONATOS_SUCCESS,
  CREATE_OPTOMETRIA_NEONATOS_FAILURE,
  FETCH_OPTOMETRIA_NEONATOS_REQUEST,
  FETCH_OPTOMETRIA_NEONATOS_SUCCESS,
  FETCH_OPTOMETRIA_NEONATOS_FAILURE,
  SET_OPTOMETRIA_NEONATOS_PAGE,
  SET_OPTOMETRIA_NEONATOS_LIMIT
} from '../../../../constants/consultas/optometria_neonatos/Optometria_neonatos';

interface OptometriaNeonatosState {
  optometrias: any[];
  currentOptometria: any | null;
  loading: boolean;
  success: boolean;
  error: string | null;
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

const INIT_STATE: OptometriaNeonatosState = {
  optometrias: [],
  currentOptometria: null,
  loading: false,
  success: false,
  error: null,
  pagination: {
    total: 0,
    page: 1,
    limit: 10,
    totalPages: 0
  }
};

export default (state = INIT_STATE, action: any): OptometriaNeonatosState => {
  switch (action.type) {
    case CREATE_OPTOMETRIA_NEONATOS_REQUEST:
      return {
        ...state,
        loading: true,
        success: false,
        error: null
      };

    case CREATE_OPTOMETRIA_NEONATOS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        currentOptometria: action.payload.optometria,
        optometrias: [action.payload.optometria, ...state.optometrias],
        pagination: {
          ...state.pagination,
          total: state.pagination.total + 1,
          totalPages: Math.ceil((state.pagination.total + 1) / state.pagination.limit)
        }
      };

    case CREATE_OPTOMETRIA_NEONATOS_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };

    case FETCH_OPTOMETRIA_NEONATOS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_OPTOMETRIA_NEONATOS_SUCCESS:
      return {
        ...state,
        loading: false,
        optometrias: action.payload.data,
        pagination: {
          total: action.payload.meta.total,
          page: action.payload.meta.page,
          limit: action.payload.meta.limit,
          totalPages: action.payload.meta.totalPages
        }
      };

    case FETCH_OPTOMETRIA_NEONATOS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case SET_OPTOMETRIA_NEONATOS_PAGE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          page: action.payload
        }
      };

    case SET_OPTOMETRIA_NEONATOS_LIMIT:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          limit: action.payload,
          totalPages: Math.ceil(state.pagination.total / action.payload)
        }
      };

    default:
      return state;
  }
};